import Budgets from "@components/modules/budgets/listing";
import { useUnsavedWorkMessage } from "@components/widgets/BudgetovacIframe/hooks";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { FullScreenContainer } from "@src/components/ui-kit";
import { NavigationBudget } from "@src/components/widgets/AppSubNav/navigation-budget";
import { getQueryParamOptional } from "@src/utils/routing";
import { FormMode } from "@src/utils/types";
import { createFileRoute } from "@tanstack/react-router";
import { uniqueId } from "lodash";
import { useRouter } from "next/router";
import { useState } from "react";

const Page = () => {
  const { query } = useRouter();
  const budgetId = getQueryParamOptional("budget_id", query);
  const projectId = getQueryParamOptional("project_id", query);
  const brandId = getQueryParamOptional("brand_id", query);
  const budgetNumber = getQueryParamOptional("budgetNumber", query);

  const [iframeKey, setIFrameKey] = useState(uniqueId());

  const { message, reset } = useUnsavedWorkMessage();

  const onSelectPage = () => {
    if (!message || (message && window.confirm(message))) {
      reset();

      /**
       * Reload iframe on select the same page
       */
      setIFrameKey(uniqueId());
      return true;
    }

    return false;
  };

  return (
    <MainLayout
      fullWidth
      noBottomMargin
      noGutters
      title={t`Budgets`}
      navigation={
        <NavigationBudget mode={FormMode.CREATE} onSelect={onSelectPage} />
      }
    >
      <FullScreenContainer noBottomMargin>
        <Budgets
          iframeKey={iframeKey}
          page={"create"}
          embedded
          proposals={true}
          showMenu={false}
          budgetId={budgetId}
          clientId={brandId}
          projectId={projectId}
          budgetNumber={budgetNumber}
        />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/proposals/create")({
  component: Page,
});
